import { HotelsList } from '@/components/hotels';
import { hotelCrudConfig, type Hotel } from '@/config/objects/hotels';
import { useApiClient, type CrudConfig } from '@startupquickstart/frontend';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from '@startupquickstart/frontend';

export function GreaterAreaHotelsTab() {
  const { id } = useParams<{ id: string }>();
  const apiClient = useApiClient();

  const config: CrudConfig<Hotel> = useMemo(
    () => ({
      ...hotelCrudConfig,
      entityName: 'Hotel',
      entityNamePlural: 'Hotels',
      endpoints: {
        ...hotelCrudConfig.endpoints,
        list: `/greater-areas/${id}/hotels`,
        delete: (hotelId: string) => `/greater-areas/${id}/hotels/${hotelId}`,
      },
      listView: {
        ...hotelCrudConfig.listView,
        actions: {
          add: {
            enabled: true,
            endpoint: '/hotels',
            where: {
              greaterAreaId: {
                not: id,
              },
            },
            onAdd: async (hotel: Hotel) => {
              await apiClient.post(`/greater-areas/${id}/hotels`, { hotelId: hotel.id });
              toast.success('Hotel added to greater area');
            },
          },
          view: {
            enabled: true,
          },
          remove: {
            enabled: true,
            onRemove: async (hotel: Hotel) => {
              await apiClient.delete(`/greater-areas/${id}/hotels/${hotel.id}`);
              toast.success('Hotel removed from greater area');
            },
          },
        },
      },
    }),
    [id, apiClient],
  );

  if (!id) return null;

  return <HotelsList config={config} className="p-0" baseUrl="/hotels" />;
}
